import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LandingPage from "./Screens/LandingPage";
import AboutPage from "./Screens/AboutPage";
import ContactPage from "./Screens/ContactPage";
import ApplicationForm from './Screens/Sections/ApplicationForm';
import ApplicationStatus from './Screens/Components/ApplicationStatus';

function AnimatedRoute() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/start-application" element={<ApplicationForm />} />
        <Route path="/edit-application/:id" element={<ApplicationForm />} />
        <Route path="/application-status/:id" element={<ApplicationStatus />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <AnimatedRoute />
    </Router>
  );
}

export default App;
